import { useMemo, useEffect, useState } from "react";
import Breadcrumb from "../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Link } from "react-router-dom";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { Alerts, GetSettings } from "../../../helpers";
import countryList from "react-select-country-list";
import Select from "react-select";
import MUIDataTable from "mui-datatables";
import { FaEdit, FaTrash } from "react-icons/fa";
import ThemeModal from "../../../components/cmp/ThemeModal";
import ConfModal from "../../../components/cmp/ConfModal";
import CKEditorField from "../../../components/cmp/CKEditorField";
const breadcrumbs = [
    { id: 1, label: "Dashboard", link: "/" },
    { id: 2, label: "Categories", link: "/app/post/categories" },
    { id: 3, label: "Create New", link: "/app/post/categories/create" },
];

const ShippingRateLabel = () => {
    const [isLoading, setLoading] = useState(true);
    const [shippingRateLabels, setShippingRateLabels] = useState([]);
    const [singleRateLabel, setSingleRateLabel] = useState(null);
    const [isEdit, setEdit] = useState(false);

    const handleOpenEdit = (singleRecord) => {
        setSingleRateLabel(singleRecord);
        setEdit(true)
    }

    const handleCloseEdit = () => {
        setSingleRateLabel(null);
        setEdit(false)
    }


    const options = useMemo(() => countryList().getData(), []);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Label is required")
    });


    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
       
        const resp = await GetSettings.createShippingRateLabel(values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setSubmitting(false);
            resetForm();
            getShippingRateLabels();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
            setSubmitting(false);
        }
    }


    const handleUpdate = async (values, { setSubmitting, resetForm }) => {
        const resp = await GetSettings.updateShippingRateLabel(singleRateLabel.id, values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setSubmitting(false);
            resetForm();
            getShippingRateLabels();
            handleCloseEdit();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
            setSubmitting(false);
        }
    }

    const getShippingRateLabels = async () => {
        const resp = await GetSettings.getShippingRateLabels();
        if (resp && resp.status) {
            setShippingRateLabels(resp.shipping_rate_labels);
            setLoading(false);
        }
    }

    const deleteShippingCountries = async (id) => {
        const resp = await GetSettings.deleteShippingRateLabel(id);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            getShippingRateLabels();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }


    useEffect(() => {
        getShippingRateLabels();
    }, []);

    const columns = [
        {
            name: 'SL'
        },
        {
            name: 'Labels',
            sortable: true,
        },
        {
            name: 'Actions',
            sortable: false,
        },
    ];


    const tableOptions = {
        filter: false,
        search: false,
        download: false,
        print: false,
        selectableRows: 'none'
    };




    return (
        <>
            <Breadcrumb breadcrumbs={breadcrumbs} />
            <div className="innerPageWrapper">
                <div className="container-fluid">
                    <div className="page-title">
                        <h2>
                            <BiCategory /> Add Shipping Rate Label
                        </h2>

                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">

                                    <Formik
                                        initialValues={{
                                            name: "",
                                            preview_label: ""
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                            setFieldValue,
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        {/* Country Select */}


                                                        {/* Country Label */}
                                                        <div className="form-group">
                                                            <label>Shipping Rate Label</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="name"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.name}
                                                            />
                                                            {errors.name &&
                                                                touched.name && (
                                                                    <span className="help-error">
                                                                        {errors.name}
                                                                    </span>
                                                                )}
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Show Label</label>
                                                            <Field
                                                                name="preview_label"
                                                                render={({ field, form }) => (
                                                                    <CKEditorField field={field} form={form} height={250}/>
                                                                )}
                                                            />
                                                            {errors.preview_label && touched.preview_label && (
                                                                <span className="help-error">
                                                                    {errors.preview_label}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="text-left">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary btn-block"
                                                                disabled={isSubmitting}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "150px",
                                                                }}
                                                            >
                                                                {isSubmitting ? "Submitting..." : "Submit"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </Formik>
                                </div>
                                <div className="col-md-6">

                                    <MUIDataTable
                                        title={`Shipping Rate Lebels`}
                                        data={shippingRateLabels.map((item, i) => {
                                            return [
                                                ++i,
                                                item.name,

                                                <div className={`actions`}>
                                                    <button onClick={() => handleOpenEdit(item)} className="btn btn-info btn-sm"><FaEdit /></button> | <ConfModal delId={item.id} handleDelete={deleteShippingCountries} message={'Are you sure you want delete this record!'} />
                                                </div>
                                            ]
                                        })}
                                        columns={columns}
                                        options={tableOptions}
                                    />
                                </div>
                            </div>
                            {
                                singleRateLabel !== null && <ThemeModal show={isEdit} handleHide={handleCloseEdit} title={'Update Shipping Countries'} >
                                    <Formik
                                        enableReinitialize={true}
                                        initialValues={{
                                            name: singleRateLabel.name,
                                            preview_label: singleRateLabel.preview_label
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={handleUpdate}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                            setFieldValue,
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">


                                                        {/* Country Label */}
                                                        <div className="form-group">
                                                            <label>Shipping Rate Label</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="name"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.name}
                                                            />
                                                            {errors.name &&
                                                                touched.name && (
                                                                    <span className="help-error">
                                                                        {errors.name}
                                                                    </span>
                                                                )}
                                                        </div>
                                                         <div className="form-group">
                                                            <label>Show Label</label>
                                                            <Field
                                                                name="preview_label"
                                                                render={({ field, form }) => (
                                                                    <CKEditorField field={field} form={form} height={250}/>
                                                                )}
                                                            />
                                                            {errors.preview_label && touched.preview_label && (
                                                                <span className="help-error">
                                                                    {errors.preview_label}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="text-center">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary btn-block"
                                                                disabled={isSubmitting}
                                                                style={{
                                                                    marginTop: "30px",
                                                                    width: "100%",
                                                                    maxWidth: "150px",
                                                                }}
                                                            >
                                                                {isSubmitting ? "Submitting..." : "Submit"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </Formik>
                                </ThemeModal>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ShippingRateLabel;
